<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from "vue"
import * as echarts from "echarts"

type ChartPoint = {
  name: string
  value: number
}

const props = defineProps<{
  points: ChartPoint[]
}>()

const chartRef = ref<HTMLElement | null>(null)
let chart: echarts.ECharts | null = null

function renderChart() {
  if (!chartRef.value) return
  if (!chart) chart = echarts.init(chartRef.value)

  chart.setOption({
    tooltip: { trigger: "item" },
    legend: {
      bottom: 0,
      icon: "circle",
      textStyle: { color: "#334155", fontSize: 12 },
    },
    series: [
      {
        name: "Visao operacional",
        type: "pie",
        radius: ["45%", "72%"],
        center: ["50%", "45%"],
        avoidLabelOverlap: false,
        label: { show: false },
        labelLine: { show: false },
        itemStyle: {
          borderRadius: 6,
          borderColor: "#ffffff",
          borderWidth: 2,
        },
        color: ["#dc2626", "#f59e0b", "#ea580c", "#0284c7", "#7c3aed"],
        data: props.points,
      },
    ],
  })
}

function resizeChart() {
  chart?.resize()
}

onMounted(() => {
  renderChart()
  window.addEventListener("resize", resizeChart)
})

watch(
  () => props.points,
  () => renderChart(),
  { deep: true }
)

onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeChart)
  chart?.dispose()
  chart = null
})
</script>

<template>
  <div ref="chartRef" class="h-80 w-full" />
</template>

